var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("payment_gateway.active"),
                          "label-for": "gateway",
                        },
                      },
                      [
                        _c(
                          "small",
                          { staticClass: "text-muted d-block mb-2" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("payment_gateway.active_help"))
                            ),
                          ]
                        ),
                        _c(
                          "b-form-radio-group",
                          {
                            attrs: { id: "gateway", stacked: "" },
                            model: {
                              value: _vm.selected,
                              callback: function ($$v) {
                                _vm.selected = $$v
                              },
                              expression: "selected",
                            },
                          },
                          _vm._l(_vm.options, function (option) {
                            return _c(
                              "b-form-radio",
                              {
                                key: option.value,
                                attrs: {
                                  value: option.value,
                                  disabled: !option.configured,
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "align-middle mr-2" },
                                  [_vm._v(_vm._s(option.label))]
                                ),
                                _c(
                                  "vs-chip",
                                  {
                                    staticClass: "text-base",
                                    attrs: {
                                      transparent: "",
                                      color: option.configured
                                        ? "success"
                                        : "danger",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          option.configured
                                            ? _vm.$t(
                                                "payment_gateway.configured"
                                              )
                                            : _vm.$t(
                                                "payment_gateway.not_configured"
                                              )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm.hasUnconfigured
                ? _c("div", { staticClass: "vx-row" }, [
                    _c(
                      "div",
                      { staticClass: "vx-col w-full" },
                      [
                        _c(
                          "b-alert",
                          {
                            staticClass: "p-1",
                            attrs: { variant: "warning", show: "" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "payment_gateway.not_configured_warning"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.selected && _vm.selected !== _vm.activeGateway
                ? _c("div", { staticClass: "vx-row" }, [
                    _c(
                      "div",
                      { staticClass: "vx-col w-full" },
                      [
                        _c(
                          "b-alert",
                          {
                            staticClass: "p-1",
                            attrs: { variant: "warning", show: "" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("payment_gateway.switch_warning")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col w-full flex justify-end" },
                  [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: "payment_gateway.edit",
                            expression: "'payment_gateway.edit'",
                          },
                        ],
                        attrs: {
                          variant: "primary",
                          type: "submit",
                          disabled:
                            !_vm.selected || _vm.selected === _vm.activeGateway,
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("payment_gateway.save")) + " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }